module.exports = __webpack_public_path__ + "img/pp-profile.468f2452.png";